import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';

import { TeamLineups } from '../components/TeamLineups';
import { configureReduxQuerySync } from 'common/react/components/competition-nav/utils/configure-redux-query-sync';

export const TeamLineupsProvider = ({ store, data }) => {
    useEffect(() => {
        configureReduxQuerySync(store);
    }, [store]);

    return (
        <Provider store={store}>
            <TeamLineups data={data} />
        </Provider>
    );
};

TeamLineupsProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
